import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import { Row, Col } from '../../base/Grid';

export const SwiperCarouselContainerRow = styled(Row)`
&& {
  width: 100%;
  height: 100%;
  padding-bottom: ${rem(40)};
}
`;

export const SwiperCarouselSwiperSlide = styled.div`
  display: flex;
  justify-content: center;
`;

export const SwiperCarouselSwiperSlideRow = styled(Row)`
  width: 100%;
  justify-content: center;
`;

export const SwiperCarouselSwiperSlideCol = styled(Col)`
  ${({ theme }) => {
    const smallUp = theme.useMediaQuery(theme.breakpoints.up('small'));
    let thisFlex = '0 100%';
    let thisMaxWidth = '100%';
    if (smallUp) {
      thisFlex = '0 83.33333333333334%';
      thisMaxWidth = '83.33333333333334%';
    }
    // TODO: not working
    return css`
      flex: ${thisFlex};
      max-width: ${thisMaxWidth};
    `;
  }}
`;

export const SwiperCarouselSwiperPagination = styled.div`
  && {
    width: 100%;
    bottom: 0;
  }
`;

export const SwiperCarouselSwiperNavigation = styled.div`
  ${({ theme }) => {
    const smallUp = theme.useMediaQuery(theme.breakpoints.up('small'));
    return css`
      && {
        height: ${smallUp
    ? 'unset'
    : '100%'};
        top: ${smallUp
    ? '45%'
    : 0};
        background-color: ${smallUp
    ? 'unset'
    : 'rgba(255,255,255,0.3)'};
        &::after {
          color: ${theme.colors.neutral.gray41};
        }
      }
    `;
  }}
`;
